import { Horizontal, GraviButton, MaterialIcon, Texto, Vertical, ManyTag } from '@gravitate-js/excalibrr'
import { props } from 'cypress/types/bluebird'
import { type CSSProperties, useMemo, Children } from 'react'

type EbolMappingButtonProps = React.HTMLAttributes<HTMLSpanElement> & {
  editing?: boolean
}

export const EbolMappingButton = ({ editing, children, ...rest }: EbolMappingButtonProps) => {
  const style = useMemo(() => {
    const result: CSSProperties = { minHeight: '40px', padding: '0 10px', gap: '6px', flexGrow: 1 }
    if (editing) {
      result.border = '1px solid'
      result.borderColor = 'var(--gray-500)'
      result.borderRadius = '18px'
    }
    return result
  }, [editing])

  return (
    <Horizontal style={style} alignItems='center' justifyContent='center'>
      <Vertical style={{ flexGrow: 1 }}>{children}</Vertical>
      <MaterialIcon
        icon='sync_lock'
        size={18}
        style={{
          cursor: 'pointer',
          color: `var(${editing ? '--theme-color-1' : '--gray-700'})`,
        }}
        fill
        {...rest}
      />
    </Horizontal>
  )
}
